module.exports = __webpack_public_path__ + "img/left-arrow.8fdb35cc.png";